(() => {
  if (window.MalfiniBasicCart) return;
  const commerce = () => window.MalfiniCommerce;
  const PRINTS = 10795330371931;
  const SERVICES = Object.freeze({
    heart: { id: 54336913015131, price: 400 },
    front: { id: 54336913047899, price: 800 },
    back: { id: 54336913080667, price: 800 },
    right_arm: { id: 54336913113435, price: 400 },
    left_arm: { id: 54336913146203, price: 400 },
    small_front: { id: 54368038715739, price: 400 }
  });
  const groupOf = item => item.properties?._malfini_basic_group;
  const roleOf = item => item.properties?._malfini_basic_role;
  const config = () => JSON.parse(document.getElementById('malfini-basic-cart-config')?.textContent || '{}');
  const message = key => config().messages?.[key] || key;
  const isManaged = item => Boolean(groupOf(item)) && (
    (Boolean(commerce()?.product(item.product_id)) && roleOf(item) === 'garment') ||
    (item.product_id === PRINTS && roleOf(item) === 'print')
  );
  function positionsOf(item) {
    const positions = String(item.properties?._malfini_basic_positions || '').split(',').filter(Boolean);
    if (!positions.length || new Set(positions).size !== positions.length ||
      positions.some(position => !SERVICES[position]) ||
      (positions.includes('heart') && positions.includes('front'))) throw new Error(message('invalid'));
    return positions;
  }
  function inspect(cart) {
    if (!Array.isArray(cart?.items)) throw new Error(message('invalid'));
    const groups = new Map();
    const issues = [];
    for (const item of cart.items) {
      if (item.product_id === PRINTS && !isManaged(item)) issues.push('standalone_print');
      if (Boolean(commerce()?.product(item.product_id)) && item.properties?.Acquisto === 'Personalizzato' && !isManaged(item)) issues.push('unlinked_garment');
      if (!isManaged(item)) continue;
      const group = groupOf(item);
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(item);
    }
    for (const items of groups.values()) {
      const garments = items.filter(item => roleOf(item) === 'garment');
      const prints = items.filter(item => roleOf(item) === 'print');
      if (garments.length !== 1) { issues.push('parent_count'); continue; }
      const garment = garments[0];
      let positions;
      try { positions = positionsOf(garment); if (!commerce().validPositions(commerce().product(garment.product_id), positions)) throw new Error(); } catch { issues.push('positions'); continue; }
      if (!Number.isInteger(garment.quantity) || garment.quantity < 1) issues.push('quantity');
      if (prints.length !== positions.length) issues.push('print_count');
      for (const position of positions) {
        const matching = prints.filter(item => item.variant_id === SERVICES[position].id && item.properties?._malfini_basic_position === position);
        if (matching.length !== 1) { issues.push('print_position'); continue; }
        const print = matching[0];
        if (Number(print.original_price ?? print.price) !== SERVICES[position].price) issues.push('print_price');
        if (print.quantity !== garment.quantity) issues.push('quantity_mismatch');
        if (print.parent_relationship?.parent_key !== garment.key) issues.push('parent_relationship');
      }
    }
    return { groups, issues, valid: issues.length === 0 };
  }
  function buildItems(formData, positions, group) {
    const id = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isInteger(quantity) || quantity < 1 || !group) throw new Error(message('invalid'));
    const properties = {};
    for (const [name, value] of formData.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') properties[match[1]] = value;
    }
    if (!Array.isArray(positions)) throw new Error(message('invalid'));
    if (!positions.length) {
      if (!commerce()?.variant(id)) throw new Error(message('invalid'));
      properties.Acquisto = 'Capo neutro';
      for (const key of Object.keys(properties)) {
        if (key.startsWith('_malfini_basic_') || key === 'Posizioni stampa' || key === 'Note personalizzazione' || /^upload(?:_|$)/i.test(key)) delete properties[key];
      }
      if (formData.get('selling_plan')) throw new Error(message('invalid'));
      return [{ id, quantity, properties }];
    }
    properties.Acquisto = 'Personalizzato';
    properties._malfini_basic_group = group;
    properties._malfini_basic_role = 'garment';
    properties._malfini_basic_positions = positions.join(',');
    positionsOf({ properties });
    const mapped = commerce()?.variant(id);
    const product = commerce()?.product(mapped?.product);
    if (!product || !commerce().validPositions(product, positions)) throw new Error(message('invalid'));
    const garment = { id, quantity, properties };
    if (formData.get('selling_plan')) throw new Error(message('invalid'));
    return [garment, ...positions.map(position => ({
      id: SERVICES[position].id, quantity, parent_id: id,
      properties: {
        _malfini_basic_group: group, _malfini_basic_role: 'print',
        _malfini_basic_position: position, 'Capo': 'MALFINI ' + product.model
      }
    }))];
  }
  async function request(resource, body) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/${resource}.js`, body === undefined ? {
      cache: 'no-store', headers: { Accept: 'application/json' }
    } : {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(result.description || message('error'));
    return result;
  }
  const readCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(message('error'));
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error(message('invalid'));
    return cart;
  };
  let pending = false;
  async function exclusive(action) {
    if (pending) throw new Error(message('busy'));
    pending = true;
    try { return await action(); } finally { pending = false; }
  }
  async function changeGroup(cart, key, quantity, change = body => request('change', body)) {
    if (!Number.isInteger(quantity) || quantity < 0) throw new Error(message('invalid'));
    const selected = cart.items.find(item => item.key === key);
    if (!selected || !isManaged(selected)) throw new Error(message('invalid'));
    const group = groupOf(selected);
    const groupItems = cart.items.filter(item => isManaged(item) && groupOf(item) === group);
    const garment = groupItems.find(item => roleOf(item) === 'garment');
    if (!garment || groupItems.filter(item => roleOf(item) === 'garment').length !== 1) throw new Error(message('invalid'));
    if (roleOf(selected) !== 'garment') throw new Error(message('change_garment'));
    positionsOf(garment);
    let state = await change({ id: garment.key, quantity });
    const parent = state.items.find(item => groupOf(item) === group && roleOf(item) === 'garment' && Boolean(commerce()?.product(item.product_id)));
    if (quantity === 0) {
      if (state.items.some(item => isManaged(item) && groupOf(item) === group)) throw new Error(message('invalid'));
      return state;
    }
    if (!parent || parent.quantity !== quantity) throw new Error(message('invalid'));
    for (const position of positionsOf(parent)) {
      const matches = state.items.filter(item => isManaged(item) && groupOf(item) === group && roleOf(item) === 'print' && item.properties?._malfini_basic_position === position && item.variant_id === SERVICES[position].id);
      if (matches.length !== 1) throw new Error(message('invalid'));
      if (matches[0].quantity !== parent.quantity) state = await change({ id: matches[0].key, quantity: parent.quantity });
    }
    if (!inspect(state).valid) throw new Error(message('invalid'));
    return state;
  }
  async function refresh() {
    const cart = await readCart();
    const main = document.querySelector('cart-items');
    if (main) {
      const sections = main.getSectionsToRender();
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart?sections=${sections.map(section => section.section).join(',')}`);
      if (!response.ok) throw new Error(message('error'));
      const rendered = await response.json();
      for (const section of sections) {
        const wrapper = document.getElementById(section.id);
        const target = wrapper?.querySelector(section.selector) || wrapper;
        const source = new DOMParser().parseFromString(rendered[section.section] || '', 'text/html').querySelector(section.selector);
        if (target && source) target.innerHTML = source.innerHTML;
      }
      main.classList.toggle('is-empty', cart.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);
    }
    const drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems) await drawerItems.onCartUpdate();
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}?sections=cart-icon-bubble`);
      const data = await response.json();
      if (data['cart-icon-bubble']) bubble.innerHTML = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.shopify-section')?.innerHTML || bubble.innerHTML;
    }
  }
  function report(error, owner) {
    const text = error.message || message('error');
    const target = owner?.querySelector('[data-malfini-cart-error]') || document.getElementById('malfini-basic-cart-error');
    if (target) { target.textContent = text; target.hidden = false; }
  }
  const api = {
    inspect, buildItems, changeGroup, SERVICES,
    ready: () => config().enabled === true,
    handles(owner, line) {
      return Boolean(owner.querySelector(`#Quantity-${line}, #Drawer-quantity-${line}`)?.closest('[data-malfini-basic-group]'));
    },
    async update(owner, line, quantity) {
      const row = owner.querySelector(`#Quantity-${line}, #Drawer-quantity-${line}`)?.closest('[data-malfini-basic-group]');
      if (!row) return;
      try {
        await exclusive(async () => {
          await commerce().load();
          const cart = await readCart();
          if (!api.ready()) throw new Error(message('not_ready'));
          await changeGroup(cart, row.dataset.malfiniBasicKey, Number(quantity));
        });
      } catch (error) { report(error, owner); }
      finally { try { await refresh(); } catch (error) { report(error, owner); } }
    },
    async add(form, positions) {
      return exclusive(async () => {
        await commerce().load();
        if (!api.ready()) throw new Error(message('not_ready'));
        const upload = form.querySelector('[data-malfini-upload]');
        if (upload && !upload.hidden) {
          const files = [...upload.querySelectorAll('[data-filepond-item-state]')].filter(file => !file.closest('.cl-upload--wrapper')?.hidden);
          const saved = [...upload.querySelectorAll('input[name^="properties["]')].filter(input => !input.disabled && input.value.trim());
          if (files.some(file => file.dataset.filepondItemState !== 'processing-complete') || (files.length && saved.length < files.length)) throw new Error(message('upload_pending'));
        }
        const data = new FormData(form);
        const items = buildItems(data, positions, crypto.randomUUID());
        const drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
        drawer?.setActiveElement(document.activeElement);
        const result = await request('add', { items, sections, sections_url: window.location.pathname });
        const cart = await readCart();
        if (!inspect(cart).valid) { await refresh(); throw new Error(message('invalid')); }
        if (drawer && sections.every(section => result.sections?.[section])) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...result, id: items[0].id });
        } else { window.location.assign(window.Shopify.routes.root + 'cart'); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'malfini-basic-cart', cartData: cart });
        commerce().clearSelection(commerce().variant(items[0].id).product);
        return cart;
      });
    }
  };
  window.MalfiniBasicCart = api;
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[action$="/cart"]') || event.submitter?.name !== 'checkout') return;
    if (!document.querySelector('[data-malfini-basic-group]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    exclusive(async () => {
      if (!api.ready()) throw new Error(message('not_ready'));
      await commerce().load();
      const cart = await readCart();
      if (!inspect(cart).valid) throw new Error(message('invalid'));
      window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
    }).catch(error => report(error));
  }, true);
})();

